import apiService from '@/api/apiService';

export const addAdmin = async (name, email, password) => {
    const url = '/api/admin/managers';
    const data = {
        name: name,
        email: email,
        password: password
    };

    return apiService.POST(url, data);
};
